/**
 * Endereço da API. O mesmo build estático roda em staging e produção, então a URL sai do host:
 * app.contabil.dev → api.contabil.dev; staging-app.contabil.dev → staging-api.contabil.dev.
 * Em desenvolvimento: VITE_API_URL (padrão http://localhost:3000).
 */
export function apiBaseUrl(hostname = typeof location !== 'undefined' ? location.hostname : 'localhost'): string {
  if (hostname === 'app.contabil.dev') return 'https://api.contabil.dev';
  if (hostname === 'staging-app.contabil.dev') return 'https://staging-api.contabil.dev';
  return import.meta.env.VITE_API_URL ?? 'http://localhost:3000';
}

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message);
  }
}

/** fetch na API com o cookie de sessão. Erros viram ApiError com a mensagem da API. */
export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, ...rest } = init;
  const res = await fetch(`${apiBaseUrl()}${path}`, {
    credentials: 'include',
    ...rest,
    headers: { ...(json !== undefined ? { 'content-type': 'application/json' } : {}), ...rest.headers },
    body: json !== undefined ? JSON.stringify(json) : rest.body,
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string; code?: string; message?: string };
    throw new ApiError(res.status, body.error ?? body.code ?? 'ERRO', body.message ?? 'Não foi possível concluir. Tente de novo.');
  }
  return (res.status === 204 ? undefined : await res.json()) as T;
}
